/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import clsx from 'clsx';
import { useFlags } from 'launchdarkly-react-client-sdk';
import OutsideClickHandler from 'react-outside-click-handler';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Select from 'react-select-virtualized';
import Avatar from './avatar';
// import Select from './select';
import AppState from '../store/appstate';

function UserDropDown(props) {
  const { t } = useTranslation();
  const {
    data, logout, accounts, switchAccount, selectedAccount, siteConfig,
  } = props;

  const [showMenu, setShowMenu] = useState(false);
  const [showSwitch, setShowSwitch] = useState(false);
  const history = useHistory();
  const username = AppState.useState((s) => s.authentication?.userName);
  const isTunecore = siteConfig?.display_name === 'TuneCore';

  const accountsToSort = JSON.parse(JSON.stringify(accounts));

  const handleChange = (selected) => {
    if (!selected) return;
    switchAccount(selected.value);
    setShowMenu(false);
    setShowSwitch(false);
  };

  const flags = useFlags();
  const reskinFlag = flags['publishing-dashboard-reskin'];
  const userButtonClasses = clsx(
    'flex lg:w-full font-medium focus:outline-none',
    {
      'md:bg-sentric-rebrand-mid-grey': showMenu && reskinFlag,
      'justify-between h-16 items-center pr-4 md:pl-4 md:pr-8 rounded-tl-lg': reskinFlag,
      'justify-center px-4 py-2': !reskinFlag,
      'text-old-sentric-dark-gray': !isTunecore && reskinFlag,
      'text-white font-tunecore': isTunecore && reskinFlag,
      'md:bg-tunecore-dark-element': isTunecore && reskinFlag && showMenu,
    },
  );  
  const userDropDownClasses = clsx(
    {
      'border-l ring-1 ring-black ring-opacity-5 focus:outline-none bg-white rounded-md lg:px-4 ': !reskinFlag,
      'bg-sentric-rebrand-mid-grey rounded-bl-lg pt-2 pl-4 pr-4': reskinFlag,
      'bg-tunecore-dark-element text-white': isTunecore && reskinFlag,
    },
    'origin-top-right absolute right-0 w-64 shadow-lg lg:mr-2.5',
  );
  const chevronRotateClass = clsx(
    {
      'transform rotate-180': showMenu,
    },
    '-mr-1 ml-2 h-6 w-6',
  );

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setShowMenu(false);
      }}
    >
      <div className={reskinFlag ? 'lg:w-64' : ''}>
          <button onClick={() => setShowMenu(!showMenu)} type="button" className={userButtonClasses} id="menu-button" aria-expanded="true" aria-haspopup="true">
            {reskinFlag && (
            <div className="mr-4 hidden md:block">
              <Avatar data={data} />
            </div>
            )}
            <p className="h-6">{data?.accountname}</p>
            { /* Heroicon name: solid/chevron-down */}
            <svg className={chevronRotateClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill={reskinFlag && isTunecore ? '#FFF' : reskinFlag ? '#000' : 'currentColor'}
            aria-hidden="true">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>

        {showMenu
          && (
            <div className={userDropDownClasses} role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
              <div className="relative" role="none">
                <div className={`${reskinFlag && isTunecore ? 'text-white border-none' : reskinFlag ? 'border-b border-black user-dropdown-child-border-bottom text-sm text-gray-500' : 'border-b  text-xs text-gray-500'} block w-full text-left px-4 py-2 `} role="menuitem" tabIndex="-1">
                  {t('common:user-menu-username')}
                  {' '}
                  {username}
                </div>
                {accounts?.artistaccounts?.length > 0
                  && (
                    <button id="btnUserSwitchAccount" type="button" onClick={() => setShowSwitch(!showSwitch)} className={`${reskinFlag && isTunecore ? 'text-white border-none' : reskinFlag ? 'text-gray-700' : 'text-gray-700'} block w-full text-left px-4 py-2 text-sm focus:outline-none`} role="menuitem" tabIndex="-1">
                      {t('common:user-menu-switch')}
                    </button>
                  )}

                {showSwitch
                  && (
                    <div className={reskinFlag && isTunecore ? 'bg-tunecore-dark-element' : reskinFlag ? 'pl-2 pr-4 bg-sentric-rebrand-mid-grey' : 'p-4 bg-old-sentric-content-white'} style={{ height: '380px' }}>
                      <Select
                        id="txtUserAccountSearch"
                        menuIsOpen
                        className="w-full text-old-sentric-dark-gray text-sm focus:outline-none"
                        name="artistAccount"
                        placeholder="Search..."
                        value={selectedAccount}
                        onChange={handleChange}
                        options={accountsToSort?.artistaccounts?.sort((a, b) => a.accountname.localeCompare(b.accountname)).map((s) => ({ label: s.accountname, value: s }))}
                        search
                      />
                    </div>
                  )}
                {!siteConfig.disable_add_account_button
                  && (
                    <button id="btnUserAddAccount" type="button" onClick={() => history.push('/add-account-pre')} className={`${reskinFlag && isTunecore ? 'border-none text-white' : reskinFlag && !isTunecore ? 'user-dropdown-child-border-top text-gray-700' : 'border-t text-gray-700 '} block w-full text-left px-4 py-2 text-sm`} role="menuitem" tabIndex="-1">
                      {t('common:user-menu-add')}
                    </button>
                  )}
                {/* <button type="button" onClick={() => history.push('/add-account-1')} className="border-t text-gray-700 block w-full text-left px-4 py-2 text-sm" role="menuitem" tabIndex="-1">
          Social settings
        </button> */}
                <button id="btnUserSignOut" type="button" onClick={() => logout()} className={`${reskinFlag && isTunecore ? 'border-none text-white' : reskinFlag ? 'user-dropdown-child-border-top text-gray-700' : 'text-gray-700 border-t'} block w-full text-left px-4 py-2 text-sm mb-4`} role="menuitem" tabIndex="-1">
                  {t('common:user-menu-sign-out')}
                </button>
              </div>
            </div>
          )}
      </div>
    </OutsideClickHandler>

  );
}

export default UserDropDown;
